import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "ux-patterns"
    }}>{`UX patterns`}</h1>
    <p>{`The UX patterns section includes requirements and best practices to ensure that your plugin follows Adobe user experience patterns.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "Designingforphotoshop/"
        }}>{`Designing for Photoshop`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "branding/"
        }}>{`Branding`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "messaging/"
        }}>{`Messaging`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "onboarding/"
        }}>{`Onboarding`}</a></li>
    </ul>
    <h2 {...{
      "id": "ux-requirements"
    }}>{`UX requirements`}</h2>
    <p>{`UX requirements highlight key patterns that all plugins need to follow in order to get approved by Adobe.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "83.75%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/4d99bbc94c951e9dfb006db0ceccebc0/5530d/plugindialogspecs.webp 320w", "/photoshop/uxp/2022/static/4d99bbc94c951e9dfb006db0ceccebc0/0c8fb/plugindialogspecs.webp 640w", "/photoshop/uxp/2022/static/4d99bbc94c951e9dfb006db0ceccebc0/94b1e/plugindialogspecs.webp 1280w", "/photoshop/uxp/2022/static/4d99bbc94c951e9dfb006db0ceccebc0/0b34d/plugindialogspecs.webp 1920w", "/photoshop/uxp/2022/static/4d99bbc94c951e9dfb006db0ceccebc0/e595f/plugindialogspecs.webp 2430w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/4d99bbc94c951e9dfb006db0ceccebc0/dd4a7/plugindialogspecs.png 320w", "/photoshop/uxp/2022/static/4d99bbc94c951e9dfb006db0ceccebc0/0f09e/plugindialogspecs.png 640w", "/photoshop/uxp/2022/static/4d99bbc94c951e9dfb006db0ceccebc0/bbbf7/plugindialogspecs.png 1280w", "/photoshop/uxp/2022/static/4d99bbc94c951e9dfb006db0ceccebc0/ac7a9/plugindialogspecs.png 1920w", "/photoshop/uxp/2022/static/4d99bbc94c951e9dfb006db0ceccebc0/2a278/plugindialogspecs.png 2430w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2022/static/4d99bbc94c951e9dfb006db0ceccebc0/bbbf7/plugindialogspecs.png",
            "alt": "An example showing the UX requirements for a plugin dialog",
            "title": "An example showing the UX requirements for a plugin dialog",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "ux-best-practices"
    }}>{`UX best practices`}</h2>
    <p>{`Best practices provide recommendations on plugin usability and behavior, user feedback, privacy, and interface guidelines.
These use “do” and “don’t” examples to illustrate the recommendations.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "19.375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/b10afb45779ab23edb3b8edccd6bee65/5530d/psicondosdonts.webp 320w", "/photoshop/uxp/2022/static/b10afb45779ab23edb3b8edccd6bee65/0c8fb/psicondosdonts.webp 640w", "/photoshop/uxp/2022/static/b10afb45779ab23edb3b8edccd6bee65/94b1e/psicondosdonts.webp 1280w", "/photoshop/uxp/2022/static/b10afb45779ab23edb3b8edccd6bee65/0b34d/psicondosdonts.webp 1920w", "/photoshop/uxp/2022/static/b10afb45779ab23edb3b8edccd6bee65/9acb0/psicondosdonts.webp 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/photoshop/uxp/2022/static/b10afb45779ab23edb3b8edccd6bee65/dd4a7/psicondosdonts.png 320w", "/photoshop/uxp/2022/static/b10afb45779ab23edb3b8edccd6bee65/0f09e/psicondosdonts.png 640w", "/photoshop/uxp/2022/static/b10afb45779ab23edb3b8edccd6bee65/bbbf7/psicondosdonts.png 1280w", "/photoshop/uxp/2022/static/b10afb45779ab23edb3b8edccd6bee65/ac7a9/psicondosdonts.png 1920w", "/photoshop/uxp/2022/static/b10afb45779ab23edb3b8edccd6bee65/369c0/psicondosdonts.png 2490w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/photoshop/uxp/2022/static/b10afb45779ab23edb3b8edccd6bee65/bbbf7/psicondosdonts.png",
            "alt": "An example showing the UX best practices for icons in Photoshop",
            "title": "An example showing the UX best practices for icons in Photoshop",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      